// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8445 ? "bc98253f" : chunkId) + "." + {"3868":"554bc34a89b1bcfc","5550":"f343ce3e0d2cca70","7667":"bedab9bdc4e2774e","8445":"886765ba4e10f842","8848":"65106ef0c2c6c697"}[chunkId] + ".js";
};